import React, { useState } from 'react';
import { Button, Input } from 'rizzui';
import { toast } from 'sonner';
import ModalForm from '../../../components/forms/ModalForm';
import useHandleErrors from '../../../hooks/useHandleErrors';
import { ContractService } from '../../../services/contract/contractService';

interface ScoreModalFormProps {
    isOpen: boolean;
    onClose: () => void;
    refetch: () => void;
    id: string;
    score: number;
    setScore: (score: number) => void;
}

const ScoreModalForm: React.FC<ScoreModalFormProps> = ({ isOpen, onClose, refetch, id, score, setScore }) => {

    const { handleErrors } = useHandleErrors();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const updateScore = async () => {
        setIsLoading(true);
        try {
            const response = await (await (new ContractService()).updateContractScore(id, score)).getResponseData();
            if (response.success) {
                toast.success('Puntuación actualizada correctamente');
                refetch();
                onClose();
                setScore(0);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            handleErrors(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ModalForm isOpen={isOpen} onClose={onClose} title='Actualización de puntuación'>
            <Input
                label='Puntuación del contrato'
                type='number'
                value={score}
                onChange={(e) => setScore(parseInt(e.target.value))}
            />

            <div className='flex justify-center p-7'>
                <Button
                    disabled={isLoading}
                    onClick={() => updateScore()}
                    color='primary'
                >
                    Actualizar puntuación
                </Button>
            </div>
        </ModalForm>
    );
};

export default ScoreModalForm;